import React from 'react';
import { Table, TableProps } from 'antd';
import { CategoryTableData } from '../types';
import TopicsTable from './TopicsTable';

interface CategoriesTableProps {
    data: CategoryTableData[];
    studentId?: string;
}

const CategoriesTable: React.FC<CategoriesTableProps> = ({ data, studentId }) => {
    const categoryColumns: TableProps<CategoryTableData>['columns'] = [
        { title: 'Skills', dataIndex: 'name', key: 'name', width: '35%', sorter: (a, b) => a.name.localeCompare(b.name) },
        { title: 'Total Activity', dataIndex: 'totalActivity', key: 'totalActivity', sorter: (a, b) => a.totalActivity - b.totalActivity },
        { title: 'Total Success', dataIndex: 'totalSuccess', key: 'totalSuccess', sorter: (a, b) => a.totalSuccess - b.totalSuccess },
        {
            title: 'Success Score (%)',
            dataIndex: 'successScore',
            key: 'successScore',
            render: (score: number) => (
                <span className={`badge badge-sm ${score >= 70 ? 'bg-success' : score > 0 ? 'bg-warning' : 'bg-secondary'} d-inline-flex align-items-center`}>
                    {score}%
                </span>
            ),
            sorter: (a, b) => a.successScore - b.successScore,
        },
    ];

    const expandedRowRender = (record: CategoryTableData) => {
        if (record.topicDetails.length === 0) {
            return <p style={{ margin: 0, padding: '10px 40px' }}>No topic-level data found for this skill.</p>;
        }
        return <TopicsTable data={record.topicDetails} isContentsVisible={record.name === "Free Writing"} studentId={studentId} />;
    };

    const CustomExpandIcon = ({ expanded, onExpand, record }: any) => (
        <span
            onClick={e => onExpand(record, e)}
            style={{
                cursor: 'pointer',
                fontSize: '14px',
                color: '#000',
                padding: '0 5px',
                transition: 'transform 0.3s ease-in-out',
                display: 'inline-block',
                transform: expanded ? 'rotate(45deg)' : 'rotate(0deg)',
                lineHeight: 1
            }}
            className="fa fa-plus"
            aria-label={expanded ? "Collapse row" : "Expand row"}
        />
    );

    return (
        <div style={{ margin: '10px 0 10px 40px' }}>
            {/* <h6 className="mb-3">Skills in this Level</h6> */}
            <Table
                dataSource={data}
                columns={categoryColumns}
                pagination={false}
                size="small"
                expandable={{
                    expandedRowRender,
                    expandIcon: CustomExpandIcon,
                    expandIconColumnIndex: 0,
                }}
            />
        </div>
    );
};

export default React.memo(CategoriesTable);